import { render, staticRenderFns } from "./WorksDlog.vue?vue&type=template&id=14c50985&scoped=true"
import script from "./WorksDlog.vue?vue&type=script&lang=js"
export * from "./WorksDlog.vue?vue&type=script&lang=js"
import style0 from "./WorksDlog.vue?vue&type=style&index=0&id=14c50985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c50985",
  null
  
)

export default component.exports